import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '../lib/metrika'

/**
 * Просмотры страниц для Метрики.
 *
 * Счётчик считает только загрузку документа, а у нас адрес меняется через
 * history: без этого весь путь ведущего «главная → пульт → проектор» выглядел
 * бы в отчётах одним просмотром главной.
 *
 * Ничего не рисует — живёт внутри роутера только ради адреса.
 */
export default function MetrikaPageViews() {
  const location = useLocation()
  const previous = useRef<string | null>(null)

  useEffect(() => {
    const url = window.location.href
    // Первый адрес уже посчитал сниппет в index.html при инициализации, поэтому
    // он только запоминается. Сравнение заодно гасит повтор эффекта в StrictMode.
    if (previous.current === url) return
    if (previous.current !== null) trackPageView(url, previous.current)
    previous.current = url
  }, [location])

  return null
}
